module.exports = __webpack_public_path__ + "img/ipc_service1.39a1ce73.png";